import { type ReactNode } from 'react'
import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'
import styles from './ReturnFiled.module.css'

export interface ReturnFiledProgressionActionsProps {
  isAnyExtensionFlowAvailable: boolean
  canCompleteJob?: boolean
  pendingActionsText: string
  onCompleteJob: () => unknown
  extensionActions?: ReactNode
}

export function ReturnFiledProgressionActions({
  isAnyExtensionFlowAvailable,
  canCompleteJob,
  pendingActionsText,
  onCompleteJob,
  extensionActions,
}: ReturnFiledProgressionActionsProps) {
  return (
    <>
      {!isAnyExtensionFlowAvailable && (
        <CardContent compactBottomPadding={isAnyExtensionFlowAvailable}>
          <Button
            label="Complete Job"
            variant="primary"
            size="wide-slim"
            onPress={onCompleteJob}
            testId="job-progression-complete-job-button"
            isDisabled={!canCompleteJob}
          />
          {!canCompleteJob && (
            <div className={styles.pendingActions}>{pendingActionsText}</div>
          )}
        </CardContent>
      )}

      {extensionActions}
    </>
  )
}
